module.exports = __webpack_public_path__ + "static/media/4.41da15f9.jpg";